



















































































































































































import "vue-pdf-app/dist/icons/main.css";

export default {
    name: 'ReportGenerator',
    props: {
        value: Boolean
    },
    components: {
        VuePdfApp: () =>
            import(/* webpackChunkName: "vue-pdf-app" */ "vue-pdf-app")            
    },
    data() {
        return {
            pdfDialog: false,
            pdfArrayBuffer: null,
            selectedSystems: [],
            generatingReport: false,
            headers: [
                {
                    text: "System Type",
                    align: "start",
                    sortable: true,
                    value: "SystemType",
                    width: "44%",
                    padding: "10px",
                    fixed: true,
                    class: "grey-header",
                },
                {
                    text: "Bay Weight (kg/m²)",
                    value: "BayUnitWeight",
                    width: "11%",
                    align: "end",
                    fixed: true,
                    class: "grey-header",
                },
                {
                    text: "Struct. Depth (mm)",
                    value: "OverallStructuralDepth",
                    width: "12%",
                    align: "end",
                    fixed: true,
                    class: "grey-header",
                },
                {
                    text: "Struct. Flr. Sys. Cost ($/m²)",
                    value: "Cost",
                    width: "13%",
                    align: "end",
                    fixed: true,
                    class: "grey-header",
                },
                {
                    text: "Carbon (kgCO₂/m²)",
                    value: "Carbon",
                    width: "15%",
                    align: "end",
                    fixed: true,
                    class: "grey-header",
                },
            ],
            items: [],
            reportTab: null,
            reportTopics: [],                
            pdfViewerConfig: {
                toolbar: {
                    toolbarViewerRight: {
                        openFile: false
                    }
                }
            },
            missingTopicDialog: false,
            reportFileName: 'TimberX.pdf',
            selectAllTopicsToggle: false
        };
    },
    async mounted() {
        this.refreshSystemsTable();
        this.getTopics();
    },
    async beforeDestroy() { },
    computed: {
        dialog: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", value);
            },
        },
    },
    methods: {
        getTopics() {
            var topics = this.$store.getters["report/reportTopics"];
            this.selectAllTopicsToggle = this.$store.getters["report/selectAllTopics"];
            this.reportTopics = topics;
        },
        toggleSelectAll() {
            this.selectAllTopicsToggle = false;
            this.$store.dispatch("report/setSelectAllToggle", false);
        },
        selectAllTopics(val) {                         
            this.reportTopics.forEach(rt => {
                rt.Topics.forEach(t => {
                    if (t.TopicName != 'No') {
                        t.IsSelected = val;    
                    }
                                        
                })
            });
            this.$store.dispatch("report/setSelectAllToggle", val);
        },
        rowClass(item) {
            var className = "";
            switch (item.MaterialType) {
                case "Timber":
                    className = "timberRow";
                    break;
                case "Concrete":
                    className = "concreteRow";
                    break;
                case "Steel":
                    className = "steelRow";
                    break;
            }
            return className;
        },
        selectSystemsToggle(props) {
            if (!props.value) {
                this.selectedSystems = this.items.filter((i) => i.MaterialType !== "Timber");
            }
        },
        async refreshSystemsTable() {
            try {
                await Promise.resolve(
                    this.items = this.$store.getters["materials/getOptionSummary"]
                );
                this.selectedSystems = this.items.filter((i) => i.MaterialType !== "Timber");
                var selTimber = this.$store.state.materials.optionSystemTypeSelected ? this.$store.state.materials.optionSystemTypeSelected : this.$store.state.materials.timberTypeSelection;
                if (selTimber) {
                    var objSelTimber = this.items.filter((i) => i.SystemType == selTimber);
                    this.selectedSystems.push(objSelTimber[0]);
                }
            } catch (error) {
            } finally {
            }
        },
        getChartImageString() {
            const srcCanvas = document.getElementById("radar-chart") as HTMLCanvasElement;    
            var destinationCanvas = document.createElement("canvas");
            destinationCanvas.width = srcCanvas.width;
            destinationCanvas.height = srcCanvas.height;

            var destCtx = destinationCanvas.getContext('2d');                
            destCtx.fillStyle = "#FFFFFF";
            destCtx.fillRect(0, 0, srcCanvas.width, srcCanvas.height);                
            destCtx.drawImage(srcCanvas, 0, 0);                
            return destinationCanvas.toDataURL().split(';base64,')[1];
        },
        async onGenerate() {
            var selTopics = [];                            
            var prefabId = null;
            this.reportTopics.forEach(rt => {
                rt.Topics.forEach(t => {
                    if (t.IsSelected) {
                        if (t.TopicName == 'No') {                                
                            prefabId = t.TopicId;
                        }
                        selTopics.push(t.TopicId);
                    }
                })
            });
            if (selTopics.length == 0) {                    
                this.missingTopicDialog = true;
                return;
            }
            if (selTopics.length == 1 && selTopics[0] == prefabId) {
                this.missingTopicDialog = true;
                return;
            }
            this.generatingReport = true;                
            var bayX = await this.$store.getters["materials/getSelectedBayX"];
            var bayY = await this.$store.getters["materials/getSelectedBayY"];
            var sector = await this.$store.getters["materials/getSelectedSector"];               
            const radarChart_base64 = this.getChartImageString();

            var selSystems = this.selectedSystems.map((s) => s.SystemType);
            var params = {
                IntroList: [
                    {
                        Location: "British Columbia",
                        Sector: sector,
                        BayXdim: bayX,
                        BayYdim: bayY
                    }
                ],
                SystemsList: selSystems,
                TopicsList: selTopics,
                RadarChartImage: radarChart_base64
            };
            try {
                this.$store
                    .dispatch("report/generateReport", params)
                    .then(async (r) => {
                        if (r && r.data) {
                            this.reportFileName = r.fileName;
                            this.pdfDialog = true;
                            this.pdfArrayBuffer = await r.data.arrayBuffer();
                        }
                        
                        this.generatingReport = false;
                    });
            } catch (e) {
                this.generatingReport = false;
            }
        }
    }
};
